// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewBookingSkeleton-goBackSkeletonBtn-iRMeC {
    max-width: 78px;
    height: 26px;
    background: var(--skeleton-secondary-bg);
    border-radius: var(--radius-5);
    margin-bottom: 18px;
}

.ViewBookingSkeleton-bookingSkeletonContainer-bar5v {
    display: grid;
    grid-template-columns: calc(100% - 428px) 404px;
    gap: 24px;
    grid-gap: 24px;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
}

.ViewBookingSkeleton-bookingSkeletonLsBox-NxHiA {
    padding: 24px;
    background: var(--background-primary);
    border-radius: var(--radius-3);
}

@media (min-width: 1200px) {
    .ViewBookingSkeleton-bookingSkeletonRsBox-_CONJ {
        position: sticky;
        top: 100px;
    }
}

@media (max-width: 1199px) and (min-width: 992px) {
    .ViewBookingSkeleton-bookingSkeletonRsBox-_CONJ {
        position: sticky;
        top: 88px;
    }
}

@media (max-width: 991px) {
    .ViewBookingSkeleton-bookingSkeletonContainer-bar5v {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        -webkit-box-align: stretch;
            -ms-flex-align: stretch;
                align-items: stretch;
    }
}

@media (max-width: 767px) {
    .ViewBookingSkeleton-bookingSkeletonLsBox-NxHiA {
        padding: 18px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Skeleton/ViewBooking/ViewBookingSkeleton/ViewBookingSkeleton.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,wCAAwC;IACxC,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,+CAAwD;IACxD,SAAS;IACT,cAAc;IACd,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,8BAA8B;AAClC;;AAEA;IACI;QACI,gBAAgB;QAChB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,SAAS;IACb;AACJ;;AAEA;IACI;QACI,oBAAa;QAAb,oBAAa;QAAb,aAAa;QACb,4BAAsB;QAAtB,6BAAsB;YAAtB,0BAAsB;gBAAtB,sBAAsB;QACtB,0BAAoB;YAApB,uBAAoB;gBAApB,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".goBackSkeletonBtn {\n    max-width: 78px;\n    height: 26px;\n    background: var(--skeleton-secondary-bg);\n    border-radius: var(--radius-5);\n    margin-bottom: 18px;\n}\n\n.bookingSkeletonContainer {\n    display: grid;\n    grid-template-columns: calc((100% - 404px) - 24px) 404px;\n    gap: 24px;\n    grid-gap: 24px;\n    align-items: flex-start;\n}\n\n.bookingSkeletonLsBox {\n    padding: 24px;\n    background: var(--background-primary);\n    border-radius: var(--radius-3);\n}\n\n@media (min-width: 1200px) {\n    .bookingSkeletonRsBox {\n        position: sticky;\n        top: 100px;\n    }\n}\n\n@media (max-width: 1199px) and (min-width: 992px) {\n    .bookingSkeletonRsBox {\n        position: sticky;\n        top: 88px;\n    }\n}\n\n@media (max-width: 991px) {\n    .bookingSkeletonContainer {\n        display: flex;\n        flex-direction: column;\n        align-items: stretch;\n    }\n}\n\n@media (max-width: 767px) {\n    .bookingSkeletonLsBox {\n        padding: 18px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"goBackSkeletonBtn": `ViewBookingSkeleton-goBackSkeletonBtn-iRMeC`,
	"bookingSkeletonContainer": `ViewBookingSkeleton-bookingSkeletonContainer-bar5v`,
	"bookingSkeletonLsBox": `ViewBookingSkeleton-bookingSkeletonLsBox-NxHiA`,
	"bookingSkeletonRsBox": `ViewBookingSkeleton-bookingSkeletonRsBox-_CONJ`
};
module.exports = ___CSS_LOADER_EXPORT___;
